import { SURVEY_FEEDBACK } from "../constants/SurveyConstants";

export const dehydrateSurveyRating = (params) => {
    return {
        rating: params === SURVEY_FEEDBACK.LIKEUP,
    };
};

export const dehydrateSurveyComment = (params) => {
    return {
        comment: params,
    };
};
